import { render, staticRenderFns } from "./DerliverViewlist.vue?vue&type=template&id=797af135&"
import script from "./DerliverViewlist.vue?vue&type=script&lang=js&"
export * from "./DerliverViewlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports